import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, Input, Segmented, Select, Space } from 'antd';
import React, { useState } from 'react';
import { STRUCTURED_DATA_FIELDS } from '../../../../../utils/const/product';

const { Option } = Select;

const StructuredDatas = ({ productDetails }) => {
  const [selectedField, setSelectedField] = useState({});
  const [open, setOpen] = useState(false);

  if (!productDetails) {
    return <div>Aucune donnée disponible</div>;
  }

  const onClose = () => {
    setOpen(false);
    setSelectedField({});
  };

  const handleShowDetails = ({ field }) => {
    setOpen(true);
    setSelectedField(field);
  };

  // TODO: enhance composition display

  return (
    <div style={{ padding: '24px' }}>
      <Form layout="vertical">
        {STRUCTURED_DATA_FIELDS(productDetails).map((field, index) => (
          <Form.Item key={`${field.key}-${index}`} label={field.label}>
            <Space.Compact style={{ width: '100%' }}>
              {field.key === 'category' ? (
                <Select value={field.value} disabled style={{ width: '75%' }}>
                  <Option value={field.value}>
                    {field.value || 'Aucune catégorie'}
                  </Option>
                </Select>
              ) : field.key === 'is_pack' ? (
                <Segmented
                  value={field.value}
                  options={['Oui', 'Non']}
                  disabled
                  style={{ width: '75%' }}
                />
              ) : field.key === 'composition' ? (
                <Input.TextArea
                  placeholder={field.value}
                  disabled
                  rows={3}
                  style={{ width: '75%' }}
                />
              ) : (
                <Input
                  placeholder={field.value}
                  disabled
                  style={{ width: '75%' }}
                  suffix={field.suffix}
                />
              )}
              <Button
                icon={<InfoCircleOutlined />}
                onClick={() => handleShowDetails({ field })}
                style={{ width: '25%' }}
              >
                Détails
              </Button>
            </Space.Compact>
          </Form.Item>
        ))}
      </Form>
      <Drawer
        title="Détails"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}
        width={500}
      >
        <Form layout="vertical">
          <Form.Item label="Variable" name="key">
            <Input placeholder={selectedField?.key} disabled />
          </Form.Item>
          <Form.Item label="Libellé" name="label">
            <Input placeholder={selectedField?.label} disabled />
          </Form.Item>
          <Form.Item label="Valeur" name="value">
            <Input placeholder={selectedField?.value} disabled />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea
              placeholder={selectedField?.description}
              disabled
              rows={4}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default StructuredDatas;
